<template>
  <div class="flex-align__between card-head">
    <div class="flex card-head__left">
      <div
        v-if="iconSrc"
        class="m-r-8 left-image"
        :style="{ width: iconWidth || '30px', height: iconHeight || '30px' }"
      >
        <el-image
          style="width: 100%; height: 100%"
          :src="iconSrc"
          fit="contain"
        />
      </div>
      <div class="left-title">{{ title }}</div>
      <el-popover
        v-if="tipCont"
        class="m-l-5"
        placement="top"
        width="200"
        trigger="hover"
        :content="tipCont"
      >
        <i slot="reference" class="iconfont icon-help"></i>
      </el-popover>
      <slot name="left"></slot>
    </div>
    <div class="card-head__right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RiskCardHead',

  props: {
    title: {
      type: String,
      default: ''
    },

    iconSrc: {
      type: [Object, String],
      default: ''
    },

    iconWidth: {
      type: [Number, String],
      default: '30px'
    },

    iconHeight: {
      type: [Number, String],
      default: '30px'
    },

    tipCont: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.card-head {
  &__left {
    .left-title {
      font-size: 24px;
      @include text-bold;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
    }
  }
}

.icon-help {
  font-size: 24px;
}
</style>
